import React from 'react'
import { Typography, Divider, withStyles } from '@material-ui/core'
import styles from './styles'
import { track } from '@amplitude/analytics-browser'
import { useHistory } from 'react-router-dom'
import { CoreButton } from 'src/components/core'

const FreeAccountModal = props => {
  const { classes } = props
  const history = useHistory()

  const handleClickRedirect = () => {
    history.push('/pricing')
  }

  return (
    <div className={classes.content}>
      <Typography className={classes.header}>
        It’s Time for Your Upgrade! 🚀
      </Typography>
      <Typography className={classes.text}>
        On our paid plans, you can build advanced AI-powered interactions like
        drag-and-drop activities, multiple-choice quizzes, and checklists — all
        fully customizable to fit your content.
      </Typography>
      <div className={classes.videoContainer}>
        <iframe
          className={classes.iframe}
          width="560"
          height="315"
          src="https://www.youtube.com/embed/HHpyM7DVMRg?si=F06remR--a0Brt4m"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <CoreButton
        color="primary"
        variant="contained"
        to="/pricing"
        className={classes.button}
        onClick={() => {
          handleClickRedirect()
        }}
      >
        See Plans & Upgrade
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(FreeAccountModal)
